import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { addFidCard } from '../../../../actions/userFidelityActions';
import Config from '../../../../axios/Config';
import {
  ADD_FID_CARD,
  ADD_FID_SCAN,
  CREATE_FID_CARD_CASHBACK,
  SCAN,
  USER_FID_CARD,
} from '../../../../constants/routes';
import {
  confirmWarning,
  notifyInfo,
  notifyWarning,
  notifyError,
  notifySuccess,
} from '../../../../utils/Notify';
import FidCardScreen from './FidCardScreen';
const UserAddFidCardScreen = () => {
  const navigate = useNavigate();
  const axiosInstance = Config();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const [_recaptchaResultToken, setRecaptchaResultToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();
  const [isSuccess, setIsSuccess] = useState(false);
  const { previousRoute, choice, companyId, companyLogo } = state || {};

  const validateFidCard = (fidCardNum) => {
    if (!fidCardNum || typeof fidCardNum !== 'string') {
      throw new Error('Numéro de carte invalide');
    }
    if (fidCardNum.trim().length === 0) {
      throw new Error('Le numéro de carte ne peut pas être vide');
    }
  };

  const checkExistingCard = (fidCardNum) => {
    if (!user?.fidCard) return { isCardWillBeReplaced: false, isCardAlreadyAdded: false };

    const isCardWillBeReplaced = user.fidCard.some(
      (card) => state?.fidCard?._id === card.fidelityCardBddId
    );
    const isCardAlreadyAdded = user.fidCard.some(
      (card) => fidCardNum === card.fidelityCardPhysicalId
    );

    return { isCardWillBeReplaced, isCardAlreadyAdded };
  };

  const onVerification = (fidCardNum) => {
    try {
      setIsLoading(true);
      validateFidCard(fidCardNum);

      const { isCardWillBeReplaced, isCardAlreadyAdded } = checkExistingCard(fidCardNum);

      if (isCardWillBeReplaced && isCardAlreadyAdded) {
        notifyInfo('Tu as déjà ajouté cette carte à ton compte.');
        setIsLoading(false);
        return;
      }

      if (isCardWillBeReplaced) {
        confirmWarning(
          'Tu as déjà une carte de fidelité',
          'Tu possèdes déjà une carte de fidélité avec cette enseigne. Souhaites-tu la remplacer ?',
          'Oui',
          () => addCard(fidCardNum)
        );
        setIsLoading(false);
        return;
      }

      addCard(fidCardNum);
    } catch (error) {
      console.error('Error in onVerification:: ', error);
      notifyError('Erreur', error.message);
      setIsLoading(false);
    }
  };

  const onSuccess = () => {
    setIsSuccess(true);
    setIsLoading(false);
    notifySuccess('Carte de fidélité ajoutée avec succès');
    if (previousRoute === CREATE_FID_CARD_CASHBACK) {
      navigate(SCAN, { state: { previousRoute: previousRoute } });
    } else {
      navigate(USER_FID_CARD);
    }
  };

  const onIdentifySuccess = async (fidCardNum, data) => {
    try {
      if (data.userMaskedEmail) {
        notifyWarning('Cette carte est déjà associée à un compte');
        setIsLoading(false);
        return;
      }

      if (!user?._id) {
        throw new Error('Informations utilisateur manquantes');
      }



      dispatch(
        addFidCard(
          axiosInstance,
          user,
          cartItems,
          fidCardNum,
          store?.id,
          onSuccess,
          setIsLoading,
          state?.fidCard?.companyId || companyId
        )
      );
    } catch (error) {
      console.error('Error in onIdentifySuccess:: ', error);
      notifyError('Erreur', 'Service momentanément indisponible');

      setIsLoading(false);
    }
  };

  const addCard = (fidCardNum) => {
    setIsLoading(true);
    onIdentifySuccess(fidCardNum, { userMaskedEmail: false });
  };

  const goToScan = () => {
    navigate(ADD_FID_SCAN, {
      state: { fidCard: state?.fidCard, prevPage: previousRoute || ADD_FID_CARD, companyId: state?.companyId || companyId, companyLogo: companyLogo || state?.image },
    });
  };

  return (
    <FidCardScreen
      onConfirm={onVerification}
      onBack={() => navigate(USER_FID_CARD)}
      goToScan={goToScan}
      companyLogo={companyLogo || state?.image}
      setRecaptchaResultToken={setRecaptchaResultToken}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      isSuccess={isSuccess}
      setIsSuccess={setIsSuccess}
      previousRoute={previousRoute}
      choice={choice}
      companyId={state?.companyId || companyId}
    />
  );
};

export default UserAddFidCardScreen;
